import { render, staticRenderFns } from "./MessagesItem.vue?vue&type=template&id=747c755a"
import script from "./MessagesItem.vue?vue&type=script&lang=js"
export * from "./MessagesItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports